import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import WebActivityScreen from "./WebActivityScreen/WebActivityScreen";
import WebAlertScreen from "./WebAlertScreen/WebAlertScreen";
import { useSelector } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import Select from "react-select";
import KidImage from "../../../shared/KidImage/KidImage";
import SetRulesDisableSupervison from "../SetRules/SetRulesDisableSupervison";
import useSetRules from "../SetRules/useSetRules";
import useFirebase from "../../../../useFirebase";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";

const WebActivity = () => {
  const history = useHistory();
  const { getLangTranslation } = useLangTranslation();
  const { handleDeviceSelection } = useDashboardDataProvider();
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { setRulesData } = useSelector(({setRules}) => setRules);
  // const [deviceData, setDeviceData] = useState(null);
  const selectedKidData = kidList?.find((item) => item?.ID === selectedKidId);
  const { handleTimeSupervision } = useSetRules();
  const { getCollectionData } = useFirebase();
  // const { getImage } = useKidListFunctionality();

  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const [deviceOptions, setDeviceOptions] = useState([]);

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
      getCollectionData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);


  // const handleDeviceChange = (value) => {
  //   setSelectedDeviceId(value);
  // };
  
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    className="text-blue-900 fs-5 cursor-pointer"
                    onClick={() => history.goBack()}
                  >
                    <i
                      className={`${lang?.isRTL === 1
                          ? "icon-arrow-right"
                          : "icon-arrow-left"
                        }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "CHILD_DETAIL_WEB_ACTIVITY",
                      "Web activity"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              {/* <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                <img
                  src={getImage(
                    selectedKidData?.image,
                    selectedKidData?.gender
                  )}
                  alt=""
                />
              </span> */}
              <KidImage imageUrl={selectedKidData?.image} gender={selectedKidData?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">
                  {selectedKidData?.childName}
                </h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon-nudity">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>

                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "WEB_ACTIVITY_SELECT_DEVICE_LABEL",
                    "Select Device"
                  )}
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
           
            <SetRulesDisableSupervison
              enableSupervision={setRulesData?.enableSupervision}
              handleTimeSupervision={handleTimeSupervision}
              deviceSelected={selectedDeviceData?.ID}
            />

          </div>
        </div>
      </div>
      <nav>
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            className="nav-link active"
            id="activityTab"
            data-bs-toggle="tab"
            data-bs-target="#Activity"
            type="button"
            role="tab"
            aria-controls="Activity"
            aria-selected="false"
          >
            {getLangTranslation("ACTIVITY", "Activity")}
          </button>

        </div>
      </nav>
      <div className="card border-0">
        <div className="card-body">
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="Activity"
              role="tabpanel"
              aria-labelledby="activityTab"
            >
              <WebActivityScreen
                selectedDeviceId={selectedDeviceData?.ID}
                getLangTranslation={getLangTranslation}
              />
            </div>
            <div
              className="tab-pane fade"
              id="alert"
              role="tabpanel"
              aria-labelledby="alertTab"
            >
              <WebAlertScreen getLangTranslation={getLangTranslation} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebActivity;
